import { defineComponent as _defineComponent } from 'vue'
import TileGridWidgetImageTile from './TileGridWidgetImageTile.vue';
import { AnalyticsPromoAttrs } from 'JS/utilities/analytics';
import { computed } from 'vue';
import { TileGridWidgetImageTile as ImageTileType, TileGridWidgetBannerTile, TileGridWidgetTileShape, TileGridWidgetTileType } from 'JS/dxp/types/widgets/tile-grid-widget';


export default /*#__PURE__*/_defineComponent({
  __name: 'TileGridWidgetBannerTile',
  props: {
    tile: null,
    promoAttrs: null
  },
  setup(__props: any) {

const props = __props as {
	tile: TileGridWidgetBannerTile;
	promoAttrs: AnalyticsPromoAttrs;
}



const mobileTile = computed((): ImageTileType => {
	return {
		type: TileGridWidgetTileType.Image,
		shape: TileGridWidgetTileShape.Full,
		imageUrl: props.tile.mobile,
		imageUrlWebP: props.tile.mobileWebP,
		imageUrlAvif: props.tile.mobileAvif,
		dimensions: props.tile.mobileDimensions,
		linkUrl: props.tile.linkUrl,
		altText: props.tile.altText,
	};
});

const tabletTile = computed((): ImageTileType => {
	return {
		type: TileGridWidgetTileType.Image,
		shape: TileGridWidgetTileShape.Full,
		imageUrl: props.tile.tablet,
		imageUrlWebP: props.tile.tabletWebP,
		imageUrlAvif: props.tile.tabletAvif,
		dimensions: props.tile.tabletDimensions,
		linkUrl: props.tile.linkUrl,
		altText: props.tile.altText,
	};
});

const desktopTile = computed((): ImageTileType => {
	return {
		type: TileGridWidgetTileType.Image,
		shape: TileGridWidgetTileShape.Full,
		imageUrl: props.tile.desktop,
		imageUrlWebP: props.tile.desktopWebP,
		imageUrlAvif: props.tile.desktopAvif,
		dimensions: props.tile.desktopDimensions,
		linkUrl: props.tile.linkUrl,
		altText: props.tile.altText,
	};
});


return { __sfc: true,props, mobileTile, tabletTile, desktopTile, TileGridWidgetImageTile }
}

})